module.exports = "/_next/static/images/891fa4c35ddb46f7e0ab3655db73f154-hero-100m-mobile.jpg";